module.exports = ".day-off-request{display:flex;justify-content:space-between}"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-time/notifications/unapproved-days-off-requests/unapproved-days-off-requests.component.scss
// module id = 496
// module chunks = 0